<template xmlns:v="http://www.w3.org/1999/xhtml">
  <div class="viewPathWrapper" v-if="nodeInfo">
    <div class="pathPart">
      <div class="viewsSegment">
        <b-dropdown class="viewButton" :text="viewButtonText">
          <template v-for="v in views">
            <b-dropdown-item @click="onViewSelected(v)" href="#" :key="v.extname">
              {{v.title}}
            </b-dropdown-item>
          </template>
        </b-dropdown>
        <img src="../../../assets/chevron.png"/>
      </div>

      <div v-for="(item, idx) in nodeInfo.namedPathList" class="pathSegment" :key="idx">
        <template v-if="idx+1 === nodeInfo.namedPathList.length">
          <b-dropdown v-if="nodeInfo.drillPathList.length>0" class="drillButton" :text="item.title">
            <template v-for="(childPath,drillIndex) in nodeInfo.drillPathList">
              <b-dropdown-item @click="onSegmentClicked(childPath.path)" href="#" :key="drillIndex">
                {{childPath.title}}
              </b-dropdown-item>
            </template>
          </b-dropdown>
          <div v-else class="endLabel">{{item.title}}</div>

        </template>
        <template v-else>
          <b-link @click="onSegmentClicked(item.path)">{{item.title}}
            <img class="normalChevron" src="../../../assets/chevron.png"/></b-link>
        </template>

      </div>
    </div>

    <div class="interviewsCountPart">
      <div class="countLabels">
        <div>{{'NO_INTERVIEWS' | i18n}}:</div>
        <div>{{'NO_TREND_INTERVIEWS' | i18n}}:</div>
      </div>
      <div class="countNumbers">
        <div>{{nodeInfo.nSelectionInterviews}}</div>
        <div>{{nodeInfo.nTrendInterviews}}</div>
      </div>
    </div>

  </div>
</template>

<script>
import {mapState} from "vuex";
import {mapGetters} from "vuex";
// import _ from 'lodash'

export default {
  name: 'ViewPathWidget',

  data() {
    return {
    }
  },

  computed: {
    ...mapGetters(['absoluteDrillPath', 'views']),
    ...mapState(["activeView", "activeStudy", "nodeInfo"]),

    viewButtonText() {
      return (this.activeView) ? this.activeView.title : "?"
    },

  },

  methods: {
    onViewButtonClicked() {
      this.$store.commit('setAbsoluteDrillPath', "")
    },

    onSegmentClicked(path) {
      // console.log(path)
      this.$store.commit('setAbsoluteDrillPath', path)
    },

    onViewSelected(v) {
      this.$store.commit('selectView', v.extname)
    },

    onBreadItemClick() {
      // console.log(i)
    },


  }

}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
.viewPathWrapper {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.pathPart {
  display: flex;
  align-items: center;
  background-color: white;
}

.interviewsCountPart {
  display: flex;
  font-size: 11px;
}

.countLabels {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  margin-right: 1em;
}

.countNumbers {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
}

.homeSegment {
  background-color: white;
}

.houseicon {
  color: black;
}

button.homeButton {
  background-color: white;
  color: black;
  border: 0;
}

button.homeButton:hover {
  background-color: white;
  color: black;
  border: 0;
  border-color: white;
}

button.homeButton:active {
  border: 0 !important;
  border-color: white !important;;
  background-color: white;
}

div.viewsSegment {
  align-self: stretch;
  background-color: white;
}

div.viewButton button {
  background-color: white;
  color: black;
  border: 0;
}

div.drillButton button {
  background-color: white;
  color: black;
  border: 0;
}

div.drillButton ul {
  max-height: 500px;
  overflow-y: auto;
}

div.pathSegment {
  background-color: white;
  color: black;
  display: flex;
  align-self: stretch;
  padding-left: 1em;
}

div.pathSegment a {
  color: black;
  /*padding-left: 2em;*/
  /*margin-right: 1em;*/
}

div.endLabel {
  display: flex;
  flex-direction: column;
  align-self: center;
  padding-right: 1em;
}

img.normalChevron {
  margin-left: 1em;
}

img.lastChevron {
  visibility: hidden;
  margin-left: 1em;
}

</style>
